import React from 'react';
import CollectionImageDesserts from 'src/assets/img/browse-by-tags/collections/desserts.png';
import CollectionFamiliarClassics from 'src/assets/img/browse-by-tags/collections/familiar_classics.png';
import CollectionImageFamilySize from 'src/assets/img/browse-by-tags/collections/family_size.png';
import CollectionImageKidFriendly from 'src/assets/img/browse-by-tags/collections/kid_friendly.png';
import CollectionWalletFriendly from 'src/assets/img/browse-by-tags/collections/wallet_friendly.png';
import { DishFirstSegmentFilter } from 'src/gqlReactTypings.generated.d';
import { DishFirstExploreWidthLimit } from 'src/pages/consumer/dish-first/explore/components/SharedStyles';
import {
  SegmentHeader,
  SegmentHeaderContainer,
  SegmentHeaderRow,
  SegmentHeaderTitle,
} from 'src/pages/consumer/dish-first/explore/styles';
import { QueryParamsUpdates, QueryParamsUpdateType } from 'src/pages/consumer/explore/useExploreUrl';
import styled, { css } from 'styled-components';
import { Mixins, Spacing } from 'web-common/src/shared/styles';
import { BrowseByTagsCollectionButtonProps, CollectionCard } from './CollectionCard';
import { BrowseByTagsCollectionTags } from './types';

const BrowseByTagsContainer = styled(DishFirstExploreWidthLimit)`
  margin-top: ${Spacing.NONE};
  margin-bottom: ${Spacing.DOUBLE_HALF};
`;

type Collection = { tag: BrowseByTagsCollectionTags; image: any; label: string };

const collectionCategories: Collection[] = [
  {
    tag: DishFirstSegmentFilter.FamilySize,
    image: CollectionImageFamilySize,
    label: 'Family style',
  },
  {
    tag: DishFirstSegmentFilter.KidFriendly,
    image: CollectionImageKidFriendly,
    label: 'Kid friendly',
  },
  {
    tag: DishFirstSegmentFilter.Desserts,
    image: CollectionImageDesserts,
    label: 'Desserts',
  },
  {
    tag: DishFirstSegmentFilter.Classics,
    image: CollectionFamiliarClassics,
    label: 'Familiar classics',
  },
  {
    tag: DishFirstSegmentFilter.WalletFriendly,
    image: CollectionWalletFriendly,
    label: 'Dishes under $12',
  },
];

const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const CardsRow = styled.div`
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr 1fr;

  display: grid;
  gap: ${Spacing.SINGLE};
  padding: ${Spacing.SINGLE};
  width: 100%;

  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }

  scroll-snap-type: x mandatory;
  & > * {
    scroll-snap-align: start;
  }

  ${Mixins.Media.maxWidthMedium(css`
    grid-template-columns: 1fr 1fr 1fr;
    scroll-snap-type: none;
  `)}

  ${Mixins.Media.maxWidthSmall(css`
    grid-template-columns: 1fr 1fr;
    scroll-snap-type: none;
  `)}

  & > * {
    opacity: 1;
    transition: opacity 0.11s ease-in-out;
  }
  .offscreen {
    opacity: 0;
  }
`;

interface BrowseByTagsFilterProps {
  updateQueryParams: (updates: QueryParamsUpdates<DishFirstSegmentFilter>, updateType?: QueryParamsUpdateType) => void;
}

export const Collections: React.FC<BrowseByTagsFilterProps> = ({ updateQueryParams }) => (
  <BrowseByTagsContainer>
    <SegmentHeaderContainer>
      <SegmentHeaderRow>
        <SegmentHeader>
          <SegmentHeaderTitle>{'Browse by collection'}</SegmentHeaderTitle>
        </SegmentHeader>
      </SegmentHeaderRow>
    </SegmentHeaderContainer>
    <CardsContainer>
      <CardsRow>
        {collectionCategories.map((p, i) => {
          const position = i + 1;
          const buttonProps: BrowseByTagsCollectionButtonProps = { ...p, position, updateQueryParams };
          return <CollectionCard key={p.tag} {...buttonProps} />;
        })}
      </CardsRow>
    </CardsContainer>
  </BrowseByTagsContainer>
);
